module.exports = __webpack_public_path__ + "static/media/joshua-oluwagbemiga.3239e783.png";